import navCourse    from './components/navCourse';
import Accordion    from './components/accordionMini';
import header       from './components/header';
import burger       from './components/burger';
import DropPanel    from './components/DropPanel';
import smoothScroll from './components/smoothScroll';
// import MainMenu  from './components/MainMenu';

// Init
function init() {
	const dropPanel = new DropPanel();
	Accordion();
	header();
	burger();
	smoothScroll();
	navCourse();

	const banner = document.querySelector('.banner');

	if (banner) {
		const bannerClose = () => {
			const closeBanner = document.querySelector('.banner__close');

			closeBanner.addEventListener('click', () => {
				banner.classList.remove('active');
			});
		};
		bannerClose();
	}
}

(function () {
	init();
}());
